var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampanella(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "#1F1F1F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.1777 61.5V46.2C76.1777 35.3 69.7777 25.6 59.7777 21.4L59.5777 21.3V19.4C59.5777 13.9 55.0777 9.40002 49.5777 9.40002C44.0777 9.40002 39.5777 13.9 39.5777 19.4V21.3L39.3777 21.4C29.3777 25.6 22.9777 35.3 22.9777 46.2V61.5L15.3777 73.4C14.8777 74.1 14.8777 75 15.2777 75.7C15.6777 76.4 16.4777 76.9 17.2777 76.9H37.6777L37.7777 77.2C39.1777 82.6 43.9777 86.4 49.5777 86.4H49.7777C55.3777 86.4 60.1777 82.6 61.5777 77.2L61.6777 76.9H82.0777C82.8777 76.9 83.6777 76.4 84.0777 75.7C84.4777 75 84.4777 74.1 83.9777 73.4L76.1777 61.5ZM44.2777 19.5C44.2777 16.5 46.6777 14.1 49.6777 14.1C52.6777 14.1 55.0777 16.5 55.0777 19.5V20L54.6777 19.9C51.4777 19.3 48.0777 19.3 44.8777 19.9L44.4777 20V19.5H44.2777ZM56.5777 77.5C55.2777 80.1 52.6777 81.8 49.7777 81.8H49.5777C46.6777 81.8 43.9777 80.1 42.7777 77.5L42.4777 77H56.7777L56.5777 77.5ZM21.4777 72.3L27.1777 63.4C27.3777 63 27.5777 62.6 27.5777 62.2V46.2C27.5777 33.9 37.4777 23.9 49.5777 23.9C61.6777 23.9 71.5777 33.9 71.5777 46.2V62.1C71.5777 62.5 71.6777 63 71.9777 63.3L77.6777 72.2H21.4777V72.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampanella);
export default __webpack_public_path__ + "static/media/campanella.1768dd0b7f15ed202503bc7d57813912.svg";
export { ForwardRef as ReactComponent };